import { TenantIsActiveDeltaRequest, CommunicationConfigClient, TenantIsActiveResponse } from 'services/tenantManagementService';
import { getTenantId } from 'features/Tenant/tenantUtils';
import store from 'base/reducer/store';
import { tryCatchJsonByAction } from 'utils/fetchUtils';
import { FetchingActionType, PersistItemsActionType } from 'features/Persist/actionTypes';

export const getMeetingTypesAction = () => {
	const tenantId = getTenantId()!;
	const client = new CommunicationConfigClient();
	return client.getMeetingTypes(tenantId);
}

export const updateMeetingTypesAction = (delta: TenantIsActiveDeltaRequest) => {
	const tenantId = getTenantId()!;
	const client = new CommunicationConfigClient();
	return client.updateMeetingTypes(tenantId, delta);
}

export const persistMeetingTypesAction = async () => {
	const state = store.getState();

	if (state.persistedMeetingType.fetching) {
		return;
	}

	store.dispatch(setFetchingAction(true));

	const response = await tryCatchJsonByAction(getMeetingTypesAction);
	if (response.success) {
		store.dispatch(setAction(response.items || []));
	} else {
		store.dispatch(setFetchingAction(false));
	}
}

// redux

export const MEETING_TYPE_FETCHING = 'MEETING_TYPE_FETCHING';
export const MEETING_TYPE_SET = 'MEETING_TYPE_SET';

const setFetchingAction = (fetching: boolean): FetchingActionType => {
	return {
		type: MEETING_TYPE_FETCHING,
		fetching
	}
}

const setAction = (items: TenantIsActiveResponse[]): PersistItemsActionType<TenantIsActiveResponse> =>  {
	return {
		type: MEETING_TYPE_SET,
		items
	}
}
